import { connect } from 'react-redux';
import React from 'react';

if (typeof window !== 'undefined') {
	import('../utils/eventHandling/handleEvents.js').then((module) => {
		module.default(window);
	});
}

export class WidgetContainer extends React.Component {
	render() {
		return <React.Fragment />;
	}
}

WidgetContainer.propTypes = {
	// mapping: PropTypes.objectOf(PropTypes.object)
};

const mapStateToProps = (_state) => {
	return {};
};

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
